import { StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import ButtonIcon from "../../../components/ButonIcon";
import { dateFormatBRWithoutHour, formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import StatusPaymentIcon from "./StatusPaymentIcon";

export default function Item({ item, onPressOptions }) {
  const initialDate = dateFormatBRWithoutHour(item.initialDate);
  const finalDate = dateFormatBRWithoutHour(item.finalDate);
  const contractActive = item.inActive

  return (
    <View style={styles.viewPrincipal}>
      <View
        style={{
          flexDirection: "row",
          marginTop: 4,
          alignItems: "center",
          backgroundColor: Colors.SECONDARY,
          width: "100%",
          justifyContent: "center",
          borderTopStartRadius: 8,
          borderTopEndRadius: 8,
          padding: 4,
        }}
      >
        <Icon name="map-marker-outline" size={24} color={Colors.WHITE} />
        <Text style={[styles.textSubItem, { fontSize: Fonts.FONT_SIZE_16, color: Colors.WHITE, }]}>
          {item.unityName}
        </Text>
      </View>
      <View style={styles.viewItem}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <StatusPaymentIcon
            active={contractActive}
            message={!contractActive ? "Contrato encerrado em " + finalDate : null}
          />
          <View>
            <View style={styles.viewSubItem}>
              <Icon name="file-account-outline" size={24} />
              <Text style={styles.textSubItem}>
                {item.contract}
              </Text>
            </View>
            <View style={styles.viewSubItem}>
              <Icon name="car" size={24} />
              <Text style={styles.textSubItem}>{item.numberOfVacancies + " Vaga(s)"}</Text>
            </View>
          </View>
          <View>
            <View style={styles.viewSubItem}>
              <Icon name="calendar" size={24} />
              <Text style={styles.textSubItem}>{initialDate}</Text>
            </View>
            <View style={styles.viewSubItem}>
              <Icon name="currency-usd" size={24} />
              <Text style={styles.textSubItem}>
                {formatMoneyBRL(item.value)}
              </Text>
            </View>
          </View>
          <ButtonIcon colorButton={Colors.PRIMARY} iconName={"magnify"} onPress={() => onPressOptions(item.id)} size={24}/>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewItem: {
    borderBottomStartRadius: 8,
    borderBottomEndRadius: 8,
    // flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
    padding: 4,
    width: "100%",
    justifyContent: "space-between",
  },
  viewPrincipal: {
    width: "100%",
    backgroundColor: Colors.SNOW,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    marginBottom: 8,
  },
  viewSubItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: 4,
  },
  receipt: {
    fontSize: Fonts.FONT_SIZE_18,
  },
  receiptView: {
    padding: 8,
    marginVertical: 16,
    flex: 1,
    flexGrow: 1,
    marginHorizontal: 8,
    opacity: 0.9,
  },
  textSubItem: {
    marginLeft: 4,
  },
  textTicketView: {
    margin: 8,
    textAlign: "center",
    justifyContent: "center",
  },
  viewBottom: {
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomEndRadius: 8,
    borderBottomStartRadius: 8,
    marginHorizontal: 8,
  },
});
